export const howWeTeach = {
  title: "Como Ensinamos",
  subtitle: "Metodologias que guiam nosso dia a dia",
  items: {
    active: {
      title: "Pedagogia Ativa / Montessori",
      description: "A criança como protagonista de sua aprendizagem através de ambientes preparados e materiais manipulativos"
    },
    global: {
      title: "Aprendizagem Global em Inglês",
      description: "Imersão progressiva: 40% na Educação Infantil, 45% no Ciclo 1, 50% no Ciclo 2, com áreas não linguísticas em inglês"
    },
    inclusion: {
      title: "Inclusão (DUA)",
      description: "Design Universal de Aprendizagem que garante acessibilidade e respeita a diversidade de cada estudante"
    },
    evaluation: {
      title: "Avaliação Amável",
      description: "Dados amáveis: observação, documentação pedagógica e feedback que acompanha sem rotular"
    }
  }
};
